<div class="warning-batch-review">
  <div class="warning-batch-review-left">
    <div class="warning-batch-review-icon">
      <img alt="attention" src="assets/icons/icon_attention_md.svg" />
    </div>
    <div class="warning-batch-review-text-wrapper">
      <div class="warning-batch-review-text">
        {{ (isISF ? "BATCH_UPLOAD_NOW_COMPLETED_ISF" : "BATCH_UPLOAD_NOW_COMPLETED_ES") | translate }}
      </div>
      <div class="warning-batch-review-text-hint">{{ "BATCH_UPLOAD_NOW_COMPLETED_HINT" | translate }}</div>
    </div>
  </div>

  <div class="warning-batch-review-right">
    <button type="button" class="warning-batch-review-btn" [routerLink]="routerLink">
      <span class="warning-batch-review-btn-inner">
        <span>{{ "GO_TO_BATCH_UPLOAD" | translate }}</span>
        <span class="warning-batch-review-btn-arrow"><img src="/assets/icons/icon_arrow_left_sm_gray.svg" /></span>
      </span>
    </button>
  </div>
</div>
